const getCrossBorderModalContainerId = (guid) => `payment-security-cross-border-modal-containerId${guid}`;
export default getCrossBorderModalContainerId;
